import { useQuery } from '@tanstack/react-query';
import { format } from 'date-fns';

import { TimeslotsResponseType } from '@src/lib/types';

export const ISO8601DateFormat = 'yyyy-MM-dd';
export const ISO8601DateTimeFormat = "yyyy-MM-dd'T'HH:mm:ss";

export async function fetchTimeSlotsForNext3Days(centerId: string | undefined, serviceId: string, startingDate: Date) {
	if (!centerId || !serviceId || !startingDate) {
		throw new Error('Center ID, Service ID and Starting date are required');
	}

	const response = await fetch(
		`${process.env.APP_PATH}/api/get-timeslots/?centerId=${centerId}&serviceId=${serviceId}&startingDate=${format(
			startingDate,
			ISO8601DateFormat
		)}`
	);

	const data = await response.json();

	if (!response.ok) {
		throw new Error(data.message);
	}

	return data as TimeslotsResponseType;
}

export function useGetTimeSlots(centerId: string | undefined, serviceId: string, startingDate: Date) {
	const { data, isFetching, error } = useQuery({
		queryKey: ['getTimeSlots', centerId, serviceId, startingDate],
		queryFn: () => fetchTimeSlotsForNext3Days(centerId, serviceId, startingDate),
		enabled: Boolean(centerId && serviceId),
	});
	return { error, isFetching, data };
}
